import { graphql } from '@apollo/client/react/hoc';
import saveCallback from './saveCallback.graphql';
import component from './component';

export default graphql(saveCallback, { name: 'saveCallback' })(component);
